"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _reactSpinner = _interopRequireDefault(require("react-spinner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const fadeAnimation = (0, _styledComponents.keyframes)`
 0% { opacity: 1; }
 100% { opacity: 0.15; }
`;
const SpinnerWithDarkProp = ({
  dark,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_reactSpinner.default, props);
var _default = exports.default = (0, _styledComponents.default)(SpinnerWithDarkProp)`
  position: relative;
  width: 32px;
  height: 32px;
  top: 50%;
  left: 50%;

  .react-spinner_bar {
    animation: 1.2s ${fadeAnimation} linear infinite;
    border-radius: 5px;
    background-color: ${props => props.dark ? 'black' : 'white'};
    position: absolute;
    width: 20%;
    height: 7.8%;
    top: -3.9%;
    left: -10%;
  }
`;